Spruce.store(
  "profile",
  {
    items: [],
    init: false,
    fetch(url) {
      fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        mode: "no-cors",
      })
        .then((response) => response.json())
        .then((json) => {
          this.init = true;
          this.items = json;
        });
    },
  },
  true
);
